<script>
  import { getAppConfig } from '../../../../common/config/app-config';
  import { isDirectionRTL } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import { sellerShopData, showSellerInfo } from '../../store/pdp_store.js';

  const soldIcon = 'icon-box';
  const premiumBadgeIcon = 'icon-verified';
  const ratingsIcon = 'icon-star';
  const { themeResourcePath, encodedContextPath } = getAppConfig();

  export let data;
  const isRTL = isDirectionRTL();
  const showSellerInfoPopup = () => {
    const shopId = data?.marketPlaceShopDetails?.id;
    const SellerDataUrl = `${encodedContextPath}/marketplace/seller/details?shopId=${shopId}`;
    fetch(SellerDataUrl)
      .then(response => response.json())
      .then(res => {
        sellerShopData.set(res);
        showSellerInfo.set(true);
      })
      .catch(err => console.log(err));
  };
</script>

<div class="mp_seller-info-wrapper" class:rtl={isRTL}>
  <div class="title-wrapper">
    <div class="mp_primary-title">
      <img class="icon-seller extra" src={`${themeResourcePath}/images/seller-icon-other.svg`} alt="" />
      <Text key="extra.marketplace.product.gettoknowseller" />
    </div>
    {#if data?.marketPlaceShopDetails?.gradeFormatted !== null}
      <div class="ratings">
        <Icon glyph={ratingsIcon} type="primary" mobileSize={18} desktopSize={24} />
        {data?.marketPlaceShopDetails?.gradeFormatted}
        <div>
          {#if data?.marketPlaceShopDetails?.evaluationCount > 0}
            ({data.marketPlaceShopDetails.evaluationCount})
          {/if}
        </div>
      </div>
    {/if}
  </div>
  <section class="mp_seller-details">
    <div class="details">
      <Icon glyph={soldIcon} type="primary" mobileSize={18} desktopSize={24} />
      <div class="mp-seller-name">
        <Text key="extra.marketplace.product.yourseller.label" />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span on:click={showSellerInfoPopup}>{data?.marketPlaceShopDetails?.name}</span>
      </div>
    </div>
  </section>
  {#if data?.marketPlaceShopDetails?.premium}
    <section class="mp_seller-premium-badge">
      <Icon glyph={premiumBadgeIcon} type="primary" mobileSize={18} desktopSize={24} />
      <Text key="extra.marketplace.product.premiumseller" />
    </section>
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .mp_seller-info-wrapper {
    background-color: $neutral-light-04;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    margin-top: 8px;
    @include responsive {
      border-radius: 8px;
      padding: 10px;
    }
    &.rtl {
      .ratings {
        flex-direction: row-reverse;
      }
    }
    .title-wrapper {
      color: $neutral-dark-01;
      display: flex;
      justify-content: space-between;
      .mp_primary-title {
        align-items: center;
        display: flex;
        font-size: 18px;
        font-weight: 700;
        line-height: 20px;
        gap: 8px;
      }
      .ratings {
        align-items: center;
        display: flex;
        font-size: 14px;
        line-height: 16px;
        gap: 4px;
        padding-right: 8px;
      }
    }
    section {
      background-color: $primary-white;
      border-radius: 8px;
      color: $neutral-dark-01;
      display: flex;
      gap: 8px;
      padding: 12px 15px;
      font-size: 16px;
      @include responsive {
        font-size: 14px;
      }
    }
    .mp_seller-details {
      display: flex;

      a {
        font-weight: 500;
        text-decoration: underline;
      }
      .details {
        display: flex;
        gap: 8px;
        max-width: 100%;
        .primary-icon {
          flex-shrink: 0;
        }
        .mp-seller-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
        span {
          color: $icon-only-icon-blue;
          cursor: pointer;
          font-weight: 500;
        }
      }
    }
  }
</style>
